<app-admin-conteiner>
    <section content>
        <app-admin-title title="Contacto" iconName="email"></app-admin-title>
        <div class="content-form__wrapper">
            <ng-container>
                <app-contact-form></app-contact-form>
            </ng-container>
        </div>
    </section>
</app-admin-conteiner>